export default __webpack_public_path__ + "static/media/Path2743.d616c84b.svg";